import React, { useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Sparkles, Mail, Copy, Check } from "lucide-react";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  const [copied, setCopied] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError(""); setResult(null);
    try {
      const res = await api.post("/auth/forgot-password", { email });
      setResult(res.data);
    } catch (err) {
      setError(err?.response?.data?.detail || "Something went wrong.");
    } finally { setLoading(false); }
  };

  const copyLink = () => {
    navigator.clipboard?.writeText(result.demo_reset_url);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <div className="w-full max-w-md glass rounded-2xl p-8 animate-fade-up">
        <div className="flex items-center gap-2 mb-6 justify-center">
          <div className="w-9 h-9 rounded-xl bg-gradient-to-br from-primary to-secondary flex items-center justify-center"><Sparkles className="w-5 h-5 text-white" /></div>
          <span className="gifted-brand text-2xl">GIFTED</span>
        </div>
        <h2 className="font-serif text-3xl mb-1 text-center">Recover your Maison access</h2>
        <p className="text-muted-foreground text-sm mb-6 text-center">Enter your email and we&apos;ll send a reset link.</p>

        {result ? (
          <div data-testid="forgot-password-result" className="text-center space-y-3">
            <div className="w-12 h-12 mx-auto rounded-full bg-secondary/15 flex items-center justify-center"><Mail className="w-6 h-6 text-secondary" /></div>
            <p className="text-sm text-foreground/90">{result.message}</p>
            {result.mode === "demo" && result.demo_reset_url && (
              <div className="surface rounded-xl p-3 text-left" data-testid="demo-reset-link">
                <p className="text-[11px] text-muted-foreground mb-1.5">Email isn&apos;t connected yet (demo mode) — here&apos;s your reset link:</p>
                <div className="flex items-center gap-2">
                  <input readOnly value={result.demo_reset_url} className="flex-1 bg-transparent text-xs text-muted-foreground truncate outline-none" />
                  <button onClick={copyLink} className="text-xs flex items-center gap-1 text-primary shrink-0">{copied ? <><Check className="w-3.5 h-3.5" /> Copied</> : <><Copy className="w-3.5 h-3.5" /> Copy</>}</button>
                </div>
              </div>
            )}
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <input data-testid="forgot-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-input border border-border rounded-lg px-4 py-2.5 focus:outline-none focus:ring-2 focus:ring-primary/50" placeholder="you@example.com" />
            {error && <div data-testid="forgot-error" className="text-sm text-red-400 bg-red-500/10 border border-red-500/20 rounded-lg px-3 py-2">{error}</div>}
            <button data-testid="forgot-submit" type="submit" disabled={loading}
              className="w-full bg-gradient-to-r from-primary to-secondary text-white font-medium rounded-lg py-3 hover:opacity-90 disabled:opacity-50">
              {loading ? "Sending…" : "Send reset link"}
            </button>
          </form>
        )}

        <div className="mt-6 text-center text-sm text-muted-foreground">
          <Link to="/login" className="text-primary hover:underline font-medium">Back to Sign In</Link>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
